import { render, staticRenderFns } from "./HiCol.vue?vue&type=template&id=42cde9cb"
import script from "./HiCol.vue?vue&type=script&lang=js"
export * from "./HiCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports